import { gReactive } from '@gradin/vue-utils'
import { ref } from 'vue'
import { useApi } from '@/functions/api'

export function useProductGroupList () {
  const api = useApi()
  const productGroups = ref<ProductGroup[]>([])
  const loading = ref(false)

  const getData = async () => {
    try {
      loading.value = true
      const response = await api.GET<ApiCollection<ProductGroup>>('warehouse/product-group')
      productGroups.value = response.data
    } finally {
      loading.value = false
    }
  }

  return {
    getData,
    loading,
    productGroups,
  }
}

export function useProductGroupCreate () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})
  const form = gReactive({
    name: '',
  })
  const productGroup = ref<ProductGroup>()

  const submitForm = async () => {
    productGroup.value = undefined
    try {
      submitting.value = true
      errors.value = {}
      productGroup.value = await api.POST<ProductGroup>('warehouse/product-group', form)
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    form,
    errors,
    submitting,
    submitForm,
    productGroup,
  }
}

export function useProductGroupEdit () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})
  const form = gReactive({
    name: '',
  })
  const productGroup = ref<ProductGroup>()
  const success = ref(false)

  const submitForm = async (id: number) => {
    success.value = false
    try {
      submitting.value = true
      productGroup.value = await api.PUT<ProductGroup>(`warehouse/product-group/${id}`, form)
      success.value = true
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    form,
    errors,
    submitting,
    submitForm,
    productGroup,
    success,
  }
}

export function useProductGroupDelete () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})
  const success = ref(false)

  const submitDelete = async (id: number) => {
    success.value = false
    try {
      submitting.value = true
      await api.DELETE(`warehouse/product-group/${id}`)
      success.value = true
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    errors,
    submitting,
    submitDelete,
    success,
  }
}
